import { Radio } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';
import { useApplicationsTableState } from 'components/Dashboard/ApplicationsTable/Context/ApplicationsTableState.context';
import { useDashboard } from 'components/Dashboard/Dashboard.context';
import { useAmplitude } from 'hooks/useAmplitude';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import { DATE_RANGES } from './DateRangeFilter.helper';
import styles from './DateRangeFilter.module.css';

export const DateRangeFilter = () => {
  const { searchApplicationDateRange } = useDashboard();
  const { trackEvent } = useAmplitude();
  const { dateRange, setDateRange } = useApplicationsTableState();

  const handleChange = (value: string) => {
    setDateRange(value);
    trackEvent(AMPLITUDE_EVENTS.monthFilterSelected, {
      Range: value,
    });
    searchApplicationDateRange(value);
  };

  return (
    <div className={styles.monthsFilters}>
      <h3 className={styles.heading}>
        <Trans>Date range</Trans>
      </h3>
      <p className={styles.subHeading}>
        <Trans>View applications in a certain period as a default.</Trans>
      </p>
      {DATE_RANGES().map((range) => (
        <Radio
          labelProps={{ className: styles.label }}
          key={range.id}
          wrapperClassName={styles.radio}
          label={range.label}
          checked={dateRange === range.id}
          onChange={() => {
            handleChange(range.id);
          }}
        />
      ))}
    </div>
  );
};
